import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

function ListadoCategorias() {
  const { user } = useContext(AuthContext);
  const URL_CRM_CATEGORIAS = process.env.REACT_APP_URL_CRM_CATEGORIAS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);
  const [nombre, setNombre] = useState("");

  useEffect(() => { getCategorias(); }, []);
  function getCategorias() {
    axios.get(URL_CRM_CATEGORIAS, headers).then((r) => setCategorias(r.data)).catch((e) => console.log(e));
  }

  function abreNuevo() { setIdEdit(null); setNombre(""); toggle(); }
  function abreEdit(a) { setIdEdit(a._id); setNombre(a.nombre); toggle(); }

  function guardar() {
    const body = { nombre };
    const req = idEdit
      ? axios.patch(`${URL_CRM_CATEGORIAS}/${idEdit}`, body, headers)
      : axios.post(URL_CRM_CATEGORIAS, body, headers);
    req
      .then(() => { toggle(); Swal.fire("Good job!", "Guardado con exito", "success"); window.location.reload(); })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "crm.categorias.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-tags" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Categorías
                </h3>
                <p className="page-subtitle">Etiquetas para clasificar prospectos</p>
              </div>
              <div className="page-actions">
                {puede(user, "crm.categorias.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Categoría
                </Button>
)}
              </div>
            </div>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Categoría</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {categorias.map((a) => (
                  <tr key={a._id}>
                    <td>{a.nombre}</td>
                    <td>
                      {puede(user, "crm.categorias.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{idEdit ? "Editar" : "Nueva"} Categoría</ModalHeader>
        <ModalBody>
          <Label>Nombre *</Label>
          <Input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoCategorias;
